import React, { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "../styles/galeria.css";

const Galeria = () => {
  const images = [
    "/galeria/1.jpg",
    "/galeria/2.jpg",
    "/galeria/3.jpg",
    "/galeria/4.jpg",
    "/galeria/5.jpg",
    "/galeria/6.jpg",
    "/galeria/7.jpg",
    "/galeria/8.jpg",
    "/galeria/9.jpg",
    "/galeria/10.jpg",
    "/galeria/11.jpg",
    "/galeria/12.jpg",

  ];

  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const timeoutRef = useRef(null);
  const manualPauseRef = useRef(null);

  // 🔹 Cambio automático de imagen
  useEffect(() => {
    if (!paused) {
      timeoutRef.current = setTimeout(() => {
        setCurrent((prev) => (prev + 1) % images.length);
      }, 3500);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [current, paused]);

  const handlePrev = () => {
    clearTimeout(timeoutRef.current);
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
    setPaused(true);
    resetAutoResume();
  };

  const handleNext = () => {
    clearTimeout(timeoutRef.current);
    setCurrent((prev) => (prev + 1) % images.length);
    setPaused(true);
    resetAutoResume();
  };

  const handleDotClick = (index) => {
    clearTimeout(timeoutRef.current);
    setCurrent(index);
    setPaused(true);
    resetAutoResume();
  };

  // 🔹 Reanudar después de 8 segundos
  const resetAutoResume = () => {
    clearTimeout(manualPauseRef.current);
    manualPauseRef.current = setTimeout(() => setPaused(false), 8000);
  };

  return (
    <section className="galeria-section">
      <h2 className="galeria-title">Nuestros Trabajos</h2>

      <div className="galeria-carousel">
        {images.map((img, index) => (
          <div
            key={index}
            className={`galeria-slide ${index === current ? "active" : ""}`}
          >
            <img
              src={img}
              alt={`Trabajo ${index + 1}`}
              loading="lazy"
              onMouseEnter={() => setPaused(true)}
              onMouseLeave={() => setPaused(false)}
            />
          </div>
        ))}

        {/* Flechas de navegación */}
        <button className="arrow left" onClick={handlePrev}>
          <ChevronLeft size={32} />
        </button>
        <button className="arrow right" onClick={handleNext}>
          <ChevronRight size={32} />
        </button>

        {/* Indicadores (puntos) */}
        <div className="galeria-dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === current ? "active" : ""}`}
              onClick={() => handleDotClick(index)}
            ></span>
          ))}
        </div>
      </div>

      <div className="galeria-botones">
        <a href="/contact" className="galeria-btn">
          Ver más en nuestras redes
        </a>
      </div>
    </section>
  );
};

export default Galeria;
